module.exports = __webpack_public_path__ + "static/media/onMarketplace App Over View - GBR Tech - 27-05-2025 C.0b1d19da.gif";